<template>
    <div class="flag_chart">
      <el-row class="mb20" type="flex" >
          <el-col :span="24">
            <el-card>
            <div>
              <el-date-picker
                v-model="value1"
                type="date"
                size="mini"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                @change="pickerDataChange"
                placeholder="选择日期">
              </el-date-picker>
            </div>
            </el-card>
          </el-col>
      </el-row>
      <el-row class="mb20" :gutter="20">
        <el-col :span="24">
          <el-card>
            <div class="charBox" ref="TodayCompleteBox"></div>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="mb20" :gutter="20">
        <el-col :span="24">
          <el-card>
            <div class="charBox" ref="flagCompleteBox"></div>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="mb20" :gutter="20">
        <el-col :span="24">
          <el-card>
            <div class="charBox" ref="AllIncomeBox"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>
</template>

<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/chart/themeRiver')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
// require('echarts/lib/component/visualMap')
export default {
  name: 'flag_chart',
  data () {
    return {
      flagCompleteChart: null,
      TodayCompleteChart: null,
      allIncomeChart: null,
      flagCompleteHeader: [],
      TodayCompleteHeader: [],
      allIncomeHeader: [],
      flagCompleteCount: [],
      TodayCompleteCount: [],
      allIncomeCount: [],
      value1: ''
    }
  },
  watch: {
    flagCompleteCount (val) {
      this.initCharts()
    },
    TodayCompleteCount (val) {
      this.initCharts()
    },
    allIncomeCount (val) {
      this.initCharts()
    }
  },
  methods: {
    pickerDataChange (val) {
      console.log(val)
      if (!val) {
        this.getAnalysisData(val)
      } else {
        this.getAnalysisData(val)
      }
    },
    getAnalysisData (timer) {
      this.$axios.get('/api/threadstat/royalty_stat', {params: {timer: timer}})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            console.log(data)
            this.flagCompleteHeader = data.data.completeStatus.header
            this.flagCompleteCount = data.data.completeStatus
            this.TodayCompleteHeader = data.data.targetData.header
            this.TodayCompleteCount = data.data.targetData
            this.allIncomeHeader = data.data.totalRoyalty.header
            this.allIncomeCount = data.data.totalRoyalty.data
          }
        })
    },
    initCharts () {
      this.flagCompleteChart = echarts.init(this.$refs.flagCompleteBox, 'light')
      this.SetFlagCompleteBox()
      this.TodayCompleteChart = echarts.init(this.$refs.TodayCompleteBox, 'light')
      this.setTodayCompleteBox()
      this.allIncomeChart = echarts.init(this.$refs.AllIncomeBox, 'light')
      this.allIncomeBox()
    },
    SetFlagCompleteBox () {
      let option = {
        title: {
          text: '今日完成情况'
        },
        color: ['#37A2DA', '#67E0E3', '#FFDB5C'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: this.flagCompleteHeader
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.flagCompleteCount.name
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: this.flagCompleteHeader[0],
            type: 'bar',
            data: this.flagCompleteCount.cloud
          },
          {
            name: this.flagCompleteHeader[1],
            type: 'bar',
            data: this.flagCompleteCount.combo
          },
          {
            name: this.flagCompleteHeader[2],
            type: 'bar',
            data: this.flagCompleteCount.item
          }
        ]
      }
      this.flagCompleteChart.setOption(option)
    },
    setTodayCompleteBox () {
      var labelOption = {
        show: true,
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'insideBottom',
        distance: 15,
        formatter: '{c}  {name|{a}}',
        fontSize: 16,
        rich: {
          name: {
            textBorderColor: '#fff'
          }
        }
      }
      let option = {
        title: {
          text: '今日目标'
        },
        color: ['#37A2DA', '#67E0E3'],
        // #FFDB5C
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: this.TodayCompleteHeader
        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: {show: true},
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {show: false},
            data: this.TodayCompleteCount.name
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: this.TodayCompleteHeader[0],
            type: 'bar',
            barGap: 0,
            label: labelOption,
            data: this.TodayCompleteCount.cloud
          },
          {
            name: this.TodayCompleteHeader[1],
            type: 'bar',
            label: labelOption,
            data: this.TodayCompleteCount.combo
          }
        ]
      }
      this.TodayCompleteChart.setOption(option)
    },
    allIncomeBox () {
      let option = {
        title: {
          text: '今日收入排名'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ['收入']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: {show: false},
          data: this.allIncomeHeader
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '收入',
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            data: this.allIncomeCount
          }
        ]
      }
      this.allIncomeChart.setOption(option)
    }
  },
  mounted () {
    this.getAnalysisData()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .clearfix:before,
  .clearfix:after
  .text-r
    text-align: right
  .flag_chart
    marginLeft()
    .mb20
      margin-bottom: .4rem
    .charBox
      width: 100%
      height: 6rem
    .cardBox
      height: 2rem
      cursor: pointer
    .cardBoxDiv
      height: 100%
    .cardBoxName
      font-size: .4rem
      font-weight: 400
      line-height: .6rem
    .activeBg
      background-color: #5787FF !important
    .activeBg2
      background-color: #FFC68E !important
    .activeBg3
      background-color: #AEA1FB !important
    .cardColor
      color: #A2A2A2
    .activeCardColor
      color: #FFFFFF
</style>



// WEBPACK FOOTER //
// src/pages/flag_manage/flag_chart/flag_chart.vue